import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  avatar: {
    width: "2rem",
    height: "2rem",
    margin: "0.5rem",
    marginBottom: "0rem",
  },
  rightBubble: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem 1rem",
    gap: "0.625rem",
    width: "11.938rem",
    background: "rgba(67, 91, 110, 0.8)",
    borderRadius: "1.5rem",
  },
  contentDiv: {
    height: "80%",
    display: "flex",
    flexDirection: "column-reverse",
    marginTop: "8rem",
    zIndex: "1",
    marginLeft: "10%",
  },
  bg: {
    height: "90vh",
    display: "flex",
  },
  bgDiv: {
    top: "7.5rem !important",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    "@media(min-width:2048px) and (min-height: 1080px)": {
      top: "20% !important",
    },
  },
  leftBubble: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem 1rem",
    gap: "0.625rem",
    width: "11.938rem",
    background: "#FFFFFF",
    borderRadius: "1.5rem",
  },
  optionDiv: {
    boxSizing: "border-box",
    background: "rgba(67, 91, 110, 0.8)",
    border: "2px solid #56CCF2",
    backdropFilter: "blur(24px)",
    borderRadius: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "1rem",
  },
  options: {
    boxSizing: "border-box",
    width: "25rem",
    height: "4.5rem",
    background: "rgba(86, 204, 242, 0.2)",
    borderRadius: "5.625rem",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    cursor: "pointer",
  },
  checkboxCircle: {
    width: "1.25rem",
    height: "1.25rem",
    borderRadius: "50%",
    boxSizing: "border-box",
    position: "fixed",
    marginLeft: "3rem",
    marginBottom: "2rem",
  },
  circle: {
    boxSizing: "border-box",
    width: "3.5rem",
    height: "3.5rem",
    background: "rgba(86, 204, 242, 0.4)",
    border: "2.25424px solid #56CCF2",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 1rem 0 7px",
  },
  circleText: {
    fontWeight: "500",
    fontSize: "1.5rem",
    textAlign: "center",
    color: "#FFFFFF",
  },
  levelText: {
    fontWeight: "700",
    fontSize: "1rem",
    color: "#FFFFFF",
    marginLeft: "1rem",
  },
  levelDiv: {
    display: "flex",
    alignItems: "center",
  },
  dropDown: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "20px 48px",
    gap: "10px",
    left: "3.72%",
    right: "3.72%",
    top: "0%",
    bottom: " 0%",
    background: "rgba(12, 13, 33, 0.4)",
    borderRadius: "12px",
  },
  typingRightDiv: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem 2rem",
    gap: "0.625rem",
    width: "1rem",
    background: "rgba(67, 91, 110, 0.8)",
    borderRadius: "1.5rem",
  },
  typingLeftDiv: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem 2rem",
    gap: "0.625rem",
    width: "1rem",
    background: "#FFFFFF",
    borderRadius: "1.5rem",
  },
  avatarDiv: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  rightGrid: {
    display: "flex",
    alignItems: "flex-end",
  },
  leftGrid: {
    display: "flex",
    alignItems: "flex-end",
  },

  actionBox: {
    width: "31rem",
    height: "23rem",
    position: "fixed",
    left: "50%",
    top: "45%",
    transform: "translate(-50%, -50%)",
  },
  actionBoxOptionsDiv: {
    boxSizing: "border-box",
    borderRadius: "20px",
    background: "rgba(67, 91, 110, 0.8)",
    border: "2px solid #56CCF2",
    backdropFilter: "blur(24px)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "2rem 9rem",
    height: "inherit",
  },
  actionBoxPill: {
    boxSizing: "border-box",
    width: "24rem",
    height: "4rem",
    background: "rgba(86, 204, 242, 0.2)",
    border: "0.125rem solid #56CCF2",
    borderRadius: "5.625rem",
    display: "flex",
    alignItems: "center",
    marginBottom: "1.5rem",
  },
  customRadioStyle: {
    "& svg": {
      width: "2.6rem",
      height: "2.6rem",
    },
    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)": {
      color: "#56CCF2",
    },
    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
      color: "white",
    },
  },
  notificationBox: {
    width: "23rem",
    height: "18rem",
    position: "fixed",
    left: "50%",
    top: "45%",
    transform: "translate(-50%, -50%)",
  },
  positionComponent: {
    position: "absolute",
    top: 0,
    width: "100%",
  },
  errorDiv: {
    backgroundColor: "#D65C5C",
    borderRadius: "1rem",
    textAlign: "center",
    padding: "0.2rem 0.5rem",
    display: "flex",
    flexDirection: "column",
  },
  consoleImage: {
    position: "absolute",
    left: "5%",
    top: "5%",
  },
  overlayDiv: {
    zIndex: "102",
    position: "fixed",
    bottom: "40px",
    justifyContent: "center",
    display: "flex",
    width: "100%",
  },
  overlayDivTypo: {
    borderRadius: "0.75rem",
    textAlign: "center",
    padding: "2rem 1.3rem",
    background: "rgba(67, 91, 110, 0.6)",
    backdropFilter: "blur(24px)",
  },
});
